import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withApollo } from 'react-apollo'
import { Button, CardBody, Col, Row, Label, Input, FormGroup, Form } from 'reactstrap'
import { CertificateDictionariesQuery } from './mutations'
import CreatableSelect from '../Wps/CreatableSelect'
import { emptyDictionaries, emptyDictionariesFieldsValues } from './CertificateForm'

class WeldersFilter extends Component {

  constructor(props) {
    super(props)
    this.state = {
      dictionaries: emptyDictionaries,
    }

    this.handleSelectStandardValueChange = this.handleSelectStandardValueChange.bind(this)
    this.handleSelectValueChange = this.handleSelectValueChange.bind(this)
    this.handleDimensionsChange = this.handleDimensionsChange.bind(this)
    this.handleDeleteInput = this.handleDeleteInput.bind(this)
    this.handleAddDynamicInput = this.handleAddDynamicInput.bind(this)
  }

  static propTypes = {
    standardsDictionary: PropTypes.array,
    filtersData: PropTypes.object.isRequired,
    formToggleFunction: PropTypes.func.isRequired,
    client: PropTypes.object.isRequired,
    submitFunction: PropTypes.func.isRequired,
    updateFiltersFunction: PropTypes.func.isRequired,
    clearFiltersDataFunction: PropTypes.func.isRequired,
  }

  componentWillMount() {
    this.fetchDictionariesData(Number(this.props.filtersData.standard_id) || Number(this.props.standardsDictionary[1].id))
  }

  fetchDictionariesData(standard_id) {
    this.props.client.query({
      query: CertificateDictionariesQuery,
      fetchPolicy: 'network-only',
      variables: {
        standard_id: standard_id,
        skip_relations: true
      }
    }).then(({ data }) => {
      this.setState({ dictionaries: data.welder_certificate_dictionaries })
    })

    return standard_id
  }

  handleSelectStandardValueChange(value) {
    if (value && Number(value.id) !== this.props.filtersData.standard_id) {
      this.fetchDictionariesData(Number(value.id))
      this.props.updateFiltersFunction({ ...emptyDictionariesFieldsValues, standard_id: Number(value.id) })
    } else {
      this.setState({ dictionaries: emptyDictionaries })
      this.props.updateFiltersFunction({ standard_id: null, ...emptyDictionariesFieldsValues })
    }
  }

  handleSelectValueChange(inputName) {
    let self = this

    function updateSelectValue(values) {
      self.props.updateFiltersFunction({ [inputName]: values.map(o => Number(o.id)) })
    }

    return updateSelectValue
  }

  handleAddDynamicInput() {
    let newValue = this.props.filtersData.dimensions || []
    newValue.push({ dimension_type: '', from: 0, to: '' })
    this.props.updateFiltersFunction({ dimensions: newValue })
  }

  handleDimensionsChange(event, idx) {
    let newValue = this.props.filtersData.dimensions
    newValue[idx][event.target.name] = (event.target.name === 'dimension_type' ? event.target.value : Number(event.target.value))
    this.props.updateFiltersFunction({ dimensions: newValue })
  }

  handleDeleteInput(idx) {
    let newValue = this.props.filtersData.dimensions
    this.props.updateFiltersFunction({ dimensions: newValue.filter((s, sidx) => idx !== sidx) })
  }

  render() {
    return (
      <CardBody>
        <Form id="welder-filters-form">
          <Row>
            <Col xs="12" sm="3">
              <Input
                id="uuid-welder-filters-form"
                name="uuid"
                type="text"
                value={this.props.filtersData.uuid || ''}
                onChange={(e) => this.props.updateFiltersFunction({ uuid: e.target.value })}
                placeholder="UUID"
              />
            </Col>
            <Col xs="12" sm="3">
              <Input
                id="first_name-welder-filters-form"
                name="first_name"
                value={this.props.filtersData.first_name || ''}
                onChange={(e) => this.props.updateFiltersFunction({ first_name: e.target.value })}
                type="text"
                placeholder="First name"
              />
            </Col>
            <Col xs="12" sm="3">
              <Input
                id="last_name-welder-filters-form"
                name="last_name"
                value={this.props.filtersData.last_name || ''}
                onChange={(e) => this.props.updateFiltersFunction({ last_name: e.target.value })}
                type="text"
                placeholder="Last name"
              />
            </Col>
            <Col xs="12" sm="3">
              <FormGroup>
                <b>Active</b>
                <FormGroup check>
                  <Label check>
                    <Input type="radio" name="active" checked={this.props.filtersData.active === true}
                      onChange={() => this.props.updateFiltersFunction({ active: true })}
                    />Yes
                  </Label>
                </FormGroup>
                <FormGroup check>
                  <Label check>
                    <Input type="radio" name="active" checked={this.props.filtersData.active === false}
                      onChange={() => this.props.updateFiltersFunction({ active: false })}
                    />No
                  </Label>
                </FormGroup>
              </FormGroup>
            </Col>
          </Row>
          <br />
          <Row>
            <Col xs="12" sm="3">
              <Input
                id="no-certificate-form"
                name="no"
                value={this.props.filtersData.no || ''}
                onChange={(e) => this.props.updateFiltersFunction({ no: e.target.value })}
                type="text"
                placeholder="Certificate no"
              />
            </Col>
            <Col xs="12" sm="3">
              <Input
                id="publisher-certificate-form"
                name="publisher"
                value={this.props.filtersData.publisher || ''}
                onChange={(e) => this.props.updateFiltersFunction({ publisher: e.target.value })}
                type="text"
                placeholder="Certificate publisher"
              />
            </Col>
          </Row>
          <br />
          <Row>
            <Col xs="12" sm="3">
              <FormGroup>
                <Label for="expiration-date-from-filter-form">Expiration date from</Label>
                <Input
                  type="date"
                  id="expiration-date-from-filter-form"
                  name="expiration_date_from"
                  value={this.props.filtersData.expiration_date_from || ''}
                  onChange={(e) => this.props.updateFiltersFunction({ expiration_date_from: e.target.value })}
                />
              </FormGroup>
            </Col>
            <Col xs="12" sm="3">
              <FormGroup>
                <Label for="expiration-date-to-filter-form">Expiration date to</Label>
                <Input
                  type="date"
                  id="expiration-date-to-filter-form"
                  name="expiration_date_to"
                  value={this.props.filtersData.expiration_date_to || ''}
                  onChange={(e) => this.props.updateFiltersFunction({ expiration_date_to: e.target.value })}
                />
              </FormGroup>
            </Col>
            <Col xs="12" sm="3">
              <FormGroup>
                <Label for="confirmation-date-from-filter-form">Confirmation date from</Label>
                <Input
                  type="date"
                  id="confirmation-date-from-filter-form"
                  name="confirmation_date_from"
                  value={this.props.filtersData.confirmation_date_from || ''}
                  onChange={(e) => this.props.updateFiltersFunction({ confirmation_date_from: e.target.value })}
                />
              </FormGroup>
            </Col>
            <Col xs="12" sm="3">
              <FormGroup>
                <Label for="confirmation-date-to-filter-form">Confirmation date to</Label>
                <Input
                  type="date"
                  id="confirmation-date-to-filter-form"
                  name="confirmation_date_to"
                  value={this.props.filtersData.confirmation_date_to || ''}
                  onChange={(e) => this.props.updateFiltersFunction({ confirmation_date_to: e.target.value })}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col xs="12" sm="4">
              <CreatableSelect id="select-standard-certificate-form"
                placeholder="Standarization"
                options={this.props.standardsDictionary}
                valueKey="id"
                value={this.props.filtersData.standard_id ||
                  (this.props.standardsDictionary.length > 0 ? this.props.standardsDictionary[1].id : null)}
                multi={false}
                creatable={false}
                valueChangeFunction={this.handleSelectStandardValueChange} />
            </Col>
            <Col xs="12" sm="4">
              <CreatableSelect id="select-welding-process-certificate-form"
                placeholder="Welding process"
                options={this.state.dictionaries.welding_processes}
                valueKey="id"
                value={this.props.filtersData.welding_process_ids || []}
                multi={true}
                creatable={false}
                valueChangeFunction={this.handleSelectValueChange('welding_process_ids')} />
            </Col>
            <Col xs="12" sm="4">
              <CreatableSelect id="select-product-type-certificate-form"
                placeholder="Product type"
                options={this.state.dictionaries.product_types}
                valueKey="id"
                value={this.props.filtersData.product_type_ids || []}
                multi={true}
                creatable={false}
                valueChangeFunction={this.handleSelectValueChange('product_type_ids')} />
            </Col>
          </Row>
          <br />
          <Row>
            <Col xs="12" sm="4">
              <CreatableSelect id="select-type-of-weld-certificate-form"
                placeholder="Type of weld"
                options={this.state.dictionaries.type_of_welds}
                valueKey="id"
                value={this.props.filtersData.type_of_weld_ids || []}
                multi={true}
                creatable={false}
                valueChangeFunction={this.handleSelectValueChange('type_of_weld_ids')} />
            </Col>
            <Col xs="12" sm="4">
              <CreatableSelect id="select-filler-material-group-certificate-form"
                placeholder="Filler material group"
                options={this.state.dictionaries.filler_material_groups}
                valueKey="id"
                value={this.props.filtersData.filler_material_group_ids || []}
                multi={true}
                creatable={false}
                valueChangeFunction={this.handleSelectValueChange('filler_material_group_ids')} />
            </Col>
            <Col xs="12" sm="4">
              <CreatableSelect id="select-filler-material-certificate-form"
                placeholder="Filler material"
                options={this.state.dictionaries.filler_materials}
                valueKey="id"
                value={this.props.filtersData.filler_material_ids || []}
                multi={true}
                creatable={false}
                valueChangeFunction={this.handleSelectValueChange('filler_material_ids')} />
            </Col>
          </Row>
          <br />
          <Row>
            <Col xs="12" sm="4">
              <CreatableSelect id="select-welding-position-certificate-form"
                placeholder="Welding position"
                options={this.state.dictionaries.welding_positions}
                valueKey="id"
                value={this.props.filtersData.welding_position_ids || []}
                multi={true}
                creatable={false}
                valueChangeFunction={this.handleSelectValueChange('welding_position_ids')} />
            </Col>
            <Col xs="12" sm="4">
              <CreatableSelect id="select-weld-detail-certificate-form"
                placeholder="Weld detail"
                options={this.state.dictionaries.weld_details}
                valueKey="id"
                value={this.props.filtersData.weld_detail_ids || []}
                multi={true}
                creatable={false}
                valueChangeFunction={this.handleSelectValueChange('weld_detail_ids')} />
            </Col>
            <Col xs="12" sm="4">
              <CreatableSelect id="select-material-group-certificate-form"
                valueKey="name"
                placeholder="Parent material group"
                value={(this.props.filtersData.material_group || []).map(o => ({ name: o }))}
                multi={true}
                creatable={true}
                valueChangeFunction={(val) => this.props.updateFiltersFunction({ material_group: (val || []).map(o => o.name) })} />
            </Col>
          </Row>
          <br />

          <Label><h5>Dimensions range</h5></Label>
          {this.props.filtersData.dimensions && this.props.filtersData.dimensions.map((dimension, idx) => {
            return (
              <div key={idx}>
                <Row>
                  <Col xs="12" sm="3">
                    <Input
                      value={dimension.dimension_type || ''}
                      type="select"
                      required
                      name="dimension_type"
                      onChange={(event) => {
                        this.handleDimensionsChange(event, idx)
                      }}
                    >
                      <option></option>
                      <option value='s'>s</option>
                      <option value='t'>t</option>
                      <option value='D'>D</option>
                    </Input>
                  </Col>
                  <Col xs="12" sm="2">
                    <Input
                      name="from"
                      value={dimension.from || ''}
                      type="number"
                      required
                      onChange={(event) => {
                        this.handleDimensionsChange(event, idx)
                      }}
                    />
                  </Col>
                  <Col xs="12" sm="2">
                    <Input
                      name="to"
                      value={dimension.to || ''}
                      type="number"
                      required
                      onChange={(event) => {
                        this.handleDimensionsChange(event, idx)
                      }}
                    />
                  </Col>
                  <Col sm="1">
                    <Button
                      color="danger"
                      onClick={() => {
                        this.handleDeleteInput(idx)
                      }}
                    >
                      <i className="fa fa-minus" />
                    </Button>
                  </Col>
                </Row>
              </div>
            )
          })}
          <Row>
            <Col sm="1">
              <Button
                color="primary"
                style={{ marginTop: '10px' }}
                onClick={this.handleAddDynamicInput}
              > <i className="fa fa-plus" />
              </Button>
            </Col>
          </Row>
          <br />
          <Button id="close-welder-filters-btn" color="danger" className="float-right"
            onClick={this.props.formToggleFunction}>
            <i className="fa fa-close" /> Close
          </Button>
          <Button id="clear-welder-filters-btn"
            className="float-right"
            onClick={() => {
              this.props.clearFiltersDataFunction()
            }}
          > <i className="fa fa-eraser" /> Clear
          </Button>
          <Button id="filter-welders-btn"
            color="primary"
            className="float-right"
            onClick={() => {
              this.props.submitFunction()
            }}
          >
            <i className="fa fa-filter" /> Apply
          </Button>
          <br /> <br />
        </Form>
      </CardBody>
    )
  }
}

export default withApollo(WeldersFilter)



// WEBPACK FOOTER //
// ./src/components/Welders/WeldersFilter.js